import React from "react";
import { TextField } from "@mui/material";

type Props = {
  component?: "input" | "textarea" | "select" | "autocomplete";
  input: any;
  id?: string;
  name?: string;
  placeholder?: string;
  defaultValue?: string;
  options?: any;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  rows?: number;
  pipe?: (value: string) => string;
};

const AddressAutocomplete: React.FC<Props> = ({
  component = "input",
  input,
  id,
  name,
  placeholder,
  defaultValue,
  options,
  disabled = false,
  readOnly = false,
  required = false,
  rows = 3,
  pipe,
  ...props
}) => {
  const handleChange = (e: any) => {
    input.onChange(pipe ? pipe(e.target.value) : e.target.value);
  };
  return (
    <>
      {component === "input" && (
        <TextField
          type="text"
          id={id}
          name={name}
          label={placeholder}
          defaultValue={defaultValue}
          disabled={disabled}
          onChange={handleChange}
          required={required}
          InputProps={{
            style: { fontFamily: "Open Sans" },
            readOnly: readOnly,
          }}
        />
      )}
    </>
  );
};

export default AddressAutocomplete;
